import type { ReactNode } from 'react';
import styled from 'styled-components';

export const ComparisonWrapper = styled.section`
  max-width: 1200px;
`;

export const Title = styled.h2`
  font-size: 32px;
  margin-bottom: 48px;
  text-align: center;
  line-height: 1.2;

  @media ${({ theme }) => theme.media.desktop} {
    font-size: 32px;
  }
`;

export const ColumnTitle = styled.h3`
  text-align: center;
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: 600;
`;

export const ComparisonGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin: 0 auto;
  max-width: 1000px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 0 1rem;
  }
`;

export const Column = styled('div')<{
  children?: ReactNode;
  type: 'pros' | 'cons';
}>`
  background-color: ${({ type }) => (type === 'pros' ? '#f0f9f0' : '#fff1f0')};
  padding: 32px;
  border-radius: 8px;
`;

export const Item = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.25rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ItemText = styled.span`
  font-size: 1.125rem;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const EmojiIcon = styled.span`
  font-size: 1.125rem;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 0.2rem;
`;
